export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  count: number;
  image: string;
  regionLabel: string;
}

export const categories: Category[] = [
  {
    slug: "zone-one",
    name: "日本一区",
    description: "涵盖关东地区核心城市群，以东京为中心，辐射周边都市圈，是日本政治、经济与文化的核心地带。",
    icon: "ri-building-2-line",
    count: 12,
    image: "https://readdy.ai/api/search-image?query=Tokyo%20cityscape%20modern%20architecture%20skyline%20with%20warm%20sunset%20lighting%2C%20elegant%20urban%20photography%2C%20clean%20composition%2C%20professional%20aesthetic%2C%20golden%20hour%20atmosphere%2C%20minimal%20color%20palette&width=800&height=500&seq=zone-one-cat&orientation=landscape",
    regionLabel: "以东京为中心的关东核心区域",
  },
  {
    slug: "zone-two",
    name: "日本二区",
    description: "涵盖关西地区历史文化名城，以大阪、京都为核心，是日本传统文化与现代商业的交融之地。",
    icon: "ri-landscape-line",
    count: 10,
    image: "https://readdy.ai/api/search-image?query=Kyoto%20traditional%20temple%20architecture%20with%20cherry%20blossom%20gardens%2C%20warm%20natural%20lighting%2C%20cultural%20heritage%20photography%2C%20serene%20atmosphere%2C%20elegant%20composition%2C%20soft%20earth%20tones%2C%20minimal%20aesthetic&width=800&height=500&seq=zone-two-cat&orientation=landscape",
    regionLabel: "以大阪、京都为核心的关西区域",
  },
  {
    slug: "comparison",
    name: "区域对比",
    description: "从经济、文化、生活成本、气候等多维度深度对比一区与二区的差异，帮助您做出最适合的选择。",
    icon: "ri-scales-3-line",
    count: 8,
    image: "https://readdy.ai/api/search-image?query=Split%20comparison%20of%20modern%20Tokyo%20and%20traditional%20Kyoto%2C%20dual%20city%20illustration%2C%20warm%20neutral%20background%2C%20editorial%20design%20style%2C%20clean%20minimal%20composition%2C%20soft%20gradient%2C%20harmonious%20color%20palette&width=800&height=500&seq=comparison-cat&orientation=landscape",
    regionLabel: "多维度区域对比分析",
  },
  {
    slug: "travel",
    name: "出行参考",
    description: "汇集一区二区的交通路线、最佳旅行时间、住宿推荐等实用出行信息，让您的日本之旅更加顺畅。",
    icon: "ri-flight-takeoff-line",
    count: 6,
    image: "https://readdy.ai/api/search-image?query=Japanese%20bullet%20train%20shinkansen%20passing%20through%20scenic%20countryside%2C%20warm%20sunlight%2C%20travel%20photography%2C%20clean%20composition%2C%20minimal%20aesthetic%2C%20soft%20natural%20tones%2C%20elegant%20atmosphere&width=800&height=500&seq=travel-cat&orientation=landscape",
    regionLabel: "交通、住宿与旅行建议",
  },
  {
    slug: "living",
    name: "生活指南",
    description: "从租房、饮食、医疗到教育资源，全面介绍在日本一区二区生活的方方面面与实用技巧。",
    icon: "ri-home-heart-line",
    count: 5,
    image: "https://readdy.ai/api/search-image?query=Cozy%20Japanese%20apartment%20interior%20with%20warm%20natural%20light%2C%20minimalist%20design%2C%20tatami%20mat%20and%20wooden%20furniture%2C%20lifestyle%20photography%2C%20clean%20composition%2C%20soft%20earth%20tones%2C%20peaceful%20atmosphere&width=800&height=500&seq=living-cat&orientation=landscape",
    regionLabel: "住房、饮食与生活实用信息",
  },
];